import { DeedAddedEvent } from '@joindeed/analytics-schema/dist/types/communities/deedAdded.schema';
import { DeedRemovedEvent } from '@joindeed/analytics-schema/dist/types/communities/deedRemoved.schema';
import { OrganizingCommunityDeedAddedEvent } from '@joindeed/analytics-schema/dist/types/communities/organizingCommunityDeedAdded.schema';
import { OrganizingCommunityDeedRemovedEvent } from '@joindeed/analytics-schema/dist/types/communities/organizingCommunityDeedRemoved.schema';

import { apolloClient } from 'entities/graphql';
import { SendSegmentEventDocument } from 'generated/graphql';
import config from 'config';

export const getAnalyticsContext = ({ userId }: { userId: string }) => ({
  eventSource: { name: 'organizer' },
  userId,
  environment: config.environment,
  publishedAt: new Date().toString(),
  userAgent: window.navigator.userAgent,
});

const sendEvent = ({
  userId,
  deedId,
  communityId,
  event,
}: {
  deedId: string;
  communityId: string;
  userId: string;
  event:
    | DeedAddedEvent
    | DeedRemovedEvent
    | OrganizingCommunityDeedAddedEvent
    | OrganizingCommunityDeedRemovedEvent;
}) =>
  apolloClient.mutate({
    mutation: SendSegmentEventDocument,
    variables: {
      event: JSON.stringify({
        event,
        properties: { deedIds: [deedId], communityId },
        version: 1,
        userId,
        context: getAnalyticsContext({ userId }),
        userAgent: window.navigator.userAgent,
      }),
    },
  });

export const logCommunityDeedEvents = ({
  deedId,
  userId,
  addedCommunityIds,
  removedCommunityIds,
  addedOrganizingCommunityIds,
  removedOrganizingCommunityIds,
}: {
  deedId: string;
  userId: string;
  addedCommunityIds: string[];
  removedCommunityIds: string[];
  addedOrganizingCommunityIds: string[];
  removedOrganizingCommunityIds: string[];
}) => {
  addedCommunityIds.forEach((communityId) => {
    void sendEvent({ deedId, communityId, userId, event: 'communities:deed-added' });
  });
  removedCommunityIds.forEach((communityId) => {
    void sendEvent({ deedId, communityId, userId, event: 'communities:deed-removed' });
  });
  addedOrganizingCommunityIds.forEach((communityId) => {
    void sendEvent({
      deedId,
      communityId,
      userId,
      event: 'communities:organizing-community-deed-added',
    });
  });
  removedOrganizingCommunityIds.forEach((communityId) => {
    void sendEvent({
      deedId,
      communityId,
      userId,
      event: 'communities:organizing-community-deed-removed',
    });
  });
};
